import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "TeamMember" }
const _hoisted_2 = { class: "TeamMember__avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "TeamMember__tag"
}
const _hoisted_5 = {
  key: 1,
  class: "TeamMember__tag"
}
const _hoisted_6 = { class: "TeamMember__info" }
const _hoisted_7 = { class: "TeamMember__nickname" }
const _hoisted_8 = {
  key: 0,
  class: "TeamMember__obtain"
}
const _hoisted_9 = { class: "TeamMember__record" }
const _hoisted_10 = {
  key: 0,
  class: "TeamMember__btnwrapper"
}
const _hoisted_11 = {
  key: 2,
  class: "TeamMember__btn TeamMember__btn--disabled"
}
const _hoisted_12 = {
  key: 1,
  class: "TeamMember__prize"
}

import { computed } from 'vue';
import { useStore } from '@/store';
import { debounce } from '@kk/utils';
import { call } from '@/api/call';
import toast from '@kk/toast';
import { useClockOn } from '@/hooks/useClockOn';
import { useShare } from '@/hooks/useShare';
import {realStrLength, cutStr} from '@/utils/text';


export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  setup(__props: any) {

const props = __props as {
  options: {
    /**
     * 获得的KK币数量
     */
    obtained: number;
    invitation: string;
    /**
     * 是否队员
     */
    isJoin: boolean;
    /**
     * 打卡天数
     */
    clockDay: number;
    userName: string;
    avatar: string;
    id: number;
    clockOn: boolean;
    myInvite: boolean;
    teamLeaderUid?: number;
  };
}

const store = useStore();
const user = computed(() => store.state.user);
const doShare = useShare();

const hasCallSet = new Set<number>();

const host = computed(() => store.state.host);




const teamLeaderUid = computed(() => {
  return props.options.teamLeaderUid || store.state.teamLeaderUid;
});

const clockInstatus = computed(() => {
  if (user.value.uid === props.options.id) {
    if (props.options.clockOn) {
      return 'disabled';
    } else {
      return 'canClockIn';
    }
  } else {
    if (props.options.clockOn) {
      return 'disabled';
    } else {
      return 'needCall';
    }
  }
});

/**
 * 喊他打卡
 */
async function callFriend () {
  try {
    if (!hasCallSet.has(props.options.id)) {
      loading.show();
      hasCallSet.add(props.options.id);
      await call(props.options.id);
      loading.hide();
    }
    if (props.options.myInvite) {
      doShare({
        title: '组队赚KK币：你今天还没打卡呐！',
        desc: `小伙伴，你的队友@${user.value.name}喊你打卡啦，快去打卡赚KK币吧`,
        shareImage: `${process.env.VUE_APP_SHARE_IMAGE}`,
      });
    } else {
      toast.show({
        text: '已通知',
      });
    }
  } catch (error) {
    console.log(error);
    loading.hide();
  }
}


const debounceCallFriend = debounce(callFriend, 500);

const {debounceClockOn} = useClockOn();

function safeNickName (name:string) {
  const safeName = name.replace(/[\x00-\x1f\x7f]/, '');
  if (realStrLength(safeName) >= 18) {
    return cutStr(safeName, 18, '...');
  } else {
    return safeName;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "TeamMember__img",
        src: __props.options.avatar ? _unref(host) + __props.options.avatar : 'https://f2.kkmh.com/default_avatar_image.jpg-w180'
      }, null, 8, _hoisted_3),
      (_unref(teamLeaderUid) === __props.options.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 队长 "))
        : _createCommentVNode("", true),
      (_unref(user).uid === __props.options.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "我"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(safeNickName(__props.options.userName)), 1),
      (__props.options.isJoin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 已赚" + _toDisplayString(__props.options.obtained) + "KK币 ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, _toDisplayString(__props.options.invitation) + "｜打卡" + _toDisplayString(__props.options.clockDay) + "天 ", 1)
    ]),
    (__props.options.isJoin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_unref(clockInstatus) === 'canClockIn')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "TeamMember__btn TeamMember__btn--active",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(debounceClockOn)()), ["stop"])),
                "data-test": "clock-on-btn"
              }, " 打卡 "))
            : _createCommentVNode("", true),
          (_unref(clockInstatus) === 'needCall')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "TeamMember__btn TeamMember__btn--call",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(debounceCallFriend) && _unref(debounceCallFriend)(...args)), ["stop"])),
                "data-test": "call-friend"
              }, " 喊ta打卡 "))
            : _createCommentVNode("", true),
          (_unref(clockInstatus) === 'disabled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 已打卡 "))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, "已赚" + _toDisplayString(__props.options.obtained) + "KK币", 1))
  ]))
}
}

})